
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unblur-image",
      function () {
        return require("private-next-pages/unblur-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unblur-image"])
      });
    }
  